import { useQuery } from "@apollo/client";
import { GET_PUBLIC_RATE_CARD } from "../graphql/operations/publicRateCard";
import type { PublicRateCard } from "../components/pricing/rateCardTypes";

/**
 * The platform's usage list prices in one currency. Returns null until the
 * query resolves so a section renders a placeholder rather than a hardcoded
 * amount that would flash and then change.
 */
export function usePublicRateCard(currency: string | null | undefined) {
    const normalized = String(currency || "usd").toLowerCase() === "inr" ? "inr" : "usd";
    const { data, loading, error } = useQuery(GET_PUBLIC_RATE_CARD, {
        variables: { currency: normalized },
        fetchPolicy: "cache-first",
    });
    const card: PublicRateCard | null = data?.publicRateCard ?? null;
    return { card, loading, error, currency: normalized as "usd" | "inr" };
}

export default usePublicRateCard;
